import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createRoot } from 'react-dom/client';
import React from 'react';
import createHeartComponent from '@finn-no/favorite-heart-component';
import { RecommendationItem } from '../../server/types.js';
import WarpElement from '@warp-ds/elements-core';
import { isItemCMS } from './utils/index.js';

@customElement('favorite-heart')
export class FavoriteHeart extends WarpElement {
	static styles = [
		...WarpElement.styles,
		css`
        /** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
        *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}.static{position:static};
		`
	];

	item!: RecommendationItem;
	favoriteBaseUrl!: string;
	loginId!: string;
	position: string = 'top-8 right-8';

	static properties = {
		item: { type: Object },
		favoriteBaseUrl: { type: String },
		loginId: { type: String },
		position: { type: String },

	};

	async firstUpdated() {
		if (isItemCMS(this.item)) return;
		const wcRef = document.querySelector('frontpage-recommendations')?.shadowRoot?.getElementById('recommendations') ?? undefined;

		const Heart = createHeartComponent({
			baseUri: this.favoriteBaseUrl,
			renderServerSide: false,
			userId: this.loginId,
			modalAttach: wcRef,
		});

		// Wait for Lit to finish rendering before querying the DOM
		await this.updateComplete;
			const heartRef = this.shadowRoot?.querySelector(`#heart-${this.item?.itemId}`);
			if (heartRef) {
				const root = createRoot(heartRef);
				root.render(
					<Heart
						variant="heart-on-image"
						itemType="Ad"
						locale={this.locale as 'en' | 'nb' | 'da' | 'fi'}
						itemId={parseInt(this.item?.itemId)}
						isMobile={false}
						renderNumFavs={false}
					/>
				);
			}
	}

	render() {
		return html`
			<div class="absolute ${this.position}" id=${`heart-${this.item?.itemId}`}></div>
		`;
	}
}

